import * as React from "react";
import { Image, tokens, makeStyles, Avatar } from "@fluentui/react-components";
import { AuthResponse } from "../../api/GateApiServer";
import { Dialog, DialogTrigger, DialogSurface, DialogBody, DialogTitle } from "@fluentui/react-components";

export interface HeaderProps {
  title: string;
  logo: string;
  message: string;
  userData: AuthResponse | null;
}

const useStyles = makeStyles({
  welcome__header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    alignItems: "center",
    paddingBottom: "8px",
    paddingTop: "8px",
    backgroundColor: tokens.colorNeutralBackground3,
  },
  avatar: {
    backgroundColor: "#1976D2", // Custom background color
    color: "#FFFFFF",           // Custom text color
    border: "2px solid #FFFFFF" // Custom border
  },
  message: {
    fontSize: '18px',
    fontWeight: 'bold',
    fontColor: '#1976D2',
    color: '#1976D2',
   
    marginTop: '8px',
    marginLeft: '8px',

  },
  messageBlack: {
    fontSize: '18px',
    fontWeight: 'bold',
    fontColor: tokens.colorNeutralBackgroundStatic,
    
    marginTop: '8px',

  },
});

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { title, logo, message, userData } = props;
  const styles = useStyles();
  const [initials, setInitials] = React.useState<string>('');
  const getInitials = (name: string, email: string): string => {
    const names = name.split(' ');
    if (names.length > 1) {
      let initials = names[0].charAt(0).toUpperCase();
      if (names.length > 1) {
        initials += names[names.length - 1].charAt(0).toUpperCase();
      }
      return initials;
    }
    else {
      const emailParts = email.split('@');
      return emailParts[0].charAt(0).toUpperCase() + emailParts[1].charAt(0).toUpperCase();
    }
  }
  React.useEffect(() => {
    if (userData) {
      setInitials(getInitials(userData.name, userData.email));
    }
  }, [userData]);
  return (
    <section className={styles.welcome__header}>
      <div style={{ display: 'flex', paddingLeft: '8px', paddingRight: '8px', alignItems: 'center' }}>
        <Image width="80" height="30" src={logo} alt={title} />
        <h1 className={styles.message}>STANDA</h1>
        <h1 className={styles.messageBlack}>LYZER</h1>
      </div>
      <div style={{ marginRight: '20px' }}>
        <Dialog>
          <DialogTrigger>
            <Avatar name={initials || "AU"} size={28} color="blue" className={styles.avatar} />
          </DialogTrigger>
          <DialogSurface>
            <DialogTitle>User Details</DialogTitle>
            <DialogBody style={{ gap: 0, display: 'flex', flexDirection: 'column' }}>
              <p><strong>ID:</strong> {userData?.id || "N/A"}</p>
              <p><strong>Microsoft ID:</strong> {userData?.microsoftId || "N/A"}</p>
              <p><strong>Name:</strong> {userData?.name || "N/A"}</p>
              <p><strong>Email:</strong> {userData?.email || "N/A"}</p>
              {/* <p><strong>Token:</strong> {userData?.token || "N/A"}</p> */}
              {/* <p><strong>Token Expiration:</strong> {userData?.tokenExpiration?.toLocaleString() || "N/A"}</p> */}
            </DialogBody>
          </DialogSurface>
        </Dialog>
      </div>
    </section>
  );
};

export default Header;
